<template>
    <section class="accriditation">
        <h2 class="title text-center">
            <span>Наш продукт LikeBG — </span>
            <span class="bordered-text nowrap">
                финансовый маркетплейс
            </span>
        </h2>
        <div class="accriditation__block">
            <b-row>
                <b-col lg="12" xl="6">
                    <div class="accriditation__item">
                        <div class="title">
                            <span class="title__accent">Программа для ЭВМ «Информационная система
                                «LikeBG»: финансовый маркетплейс»
                            </span>
                            позволяет проводить рассмотрение заявок на
                            получение/выдачу независимых гарантий на все виды закупок в рамках Федеральных законов № 44-
                            ФЗ от 05.04.2013, № 223-ФЗ от 18.07.2011, Постановления Правительства РФ от 01.07.2016 № 615
                            (№ 185-ФЗ от 21.07.2007), коммерческих гарантий.
                        </div>
                    </div>
                </b-col>
                <b-col lg="12" xl="6">
                    <div class="accriditation__item">
                        <div class="title"><span class="title__accent">Для Агентов:</span> неисключительная лицензия на
                            программное обеспечение является
                            безвозмездной.
                            <span class="title__accent">Для Банков:</span> неисключительная лицензия, размер
                            лицензионного вознаграждения и условия
                            работы подлежат согласованию в индивидуальном порядке и зависит от объёма лицензии, способа
                            использования и объёма документооборота.
                            <span class="title__accent">Вся документация</span> на программное обеспечение доступна для
                            ознакомления.
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </section>
</template>

<script>
export default {
    name: "Accreditation",
    data() {
        return {
        }
    }
}
</script>

<style lang="scss" scoped>
.accriditation {
    padding-top: 100px;

    &__block {
        margin-top: 40px;
        background: #f1f4f9;
        border-radius: 15px;
        padding: 0px 20px;

        @media (max-width: 1280px) {
            margin-top: 30px;
            padding: 0px;

            .col-xl-4 {
                flex: 0 0 auto;
                width: 100%;
                border-right: 0;
                padding: 20px 0;
                border-bottom: 1px solid #ddd;
            }

            .col-xl-4:last-child {
                border-bottom: 0;
            }

            .title {
                line-height: 50px;
                max-width: 576px;
                margin: 0 auto;
            }
        }
    }

    .bordered-text{
        display: inline-block;
        padding: 4px 14px;
        line-height: 1;
        
        @media (min-width: 1280px) {
            line-height: 1.5;
        }
    }
    .col-xl-4 {
        border-right: 1px solid #ddd;
    }

    .col-xl-4:last-child {
        border-right: 0;
    }

    &__item {
        padding: 20px 0px;

        @media (min-width: 1280px) {
            padding: 30px 0px 20px;
        }

        .title {
            font-weight: 500;
            font-size: 15px;
            line-height: 24px;
            text-align: left;
            padding: 0;


            @media (min-width: 1280px) {
                font-size: 16px;
                line-height: 28px;
            }
            
            @media (min-width: 1440px) {
                padding: 0 30px;
            }

            @media (min-width: 1920px) {
                font-size: 20px;
                line-height: 32px;
            }

            &__accent {
                color: #08a651;
            }
        }
    }
}



@media (max-width: 768px) {
    .accriditation {
        &__block .col-xl-4 {
            padding: 0;
        }

        &__item .title {
            padding: 0 30px;
        }
    }
}
</style>